<template>
  <div id="progress">
    <div class="graphics">
      <div class="item" v-for="(item, index) in sorted" :key="index">
        <div v-if="index == 0" class="block connect-left" />
        <div
          v-if="index < sorted.length - 1"
          class="connect connect-right"
          :class="{ full: current > item }"
        />
        <div v-if="index == sorted.length - 1" class="block connect-right" />
        <div class="circle" :class="{ full: current >= item }" />
        <span>{{ steps[item] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Progress",
  props: {
    current: {
      default: 0,
      type: Number,
    },
    steps: {
      type: Object,
      default() {
        return {
          0: "店内开卡",
          1: "开始上课",
          2: "兑换礼品",
        }
      }
    },
  },
  computed: {
    sorted() {
      return Object.keys(this.steps).map(Number).sort()
    }
  }
}
</script>

<style lang="scss" scoped>
#progress {
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 15px 5%;
}
$lineColor: #e8e8e8;
$circleSize: 12px;
.graphics {
  display: flex;
  justify-content: space-between;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .circle {
    width: $circleSize;
    height: $circleSize;
    border-radius: $circleSize;
    background-color: white;
    border: 2px solid $blue;
    z-index: 2;
  }
  .block {
    background: white;
    position: absolute;
    height: $circleSize;
    width: 100%;
  }
  .connect {
    height: 1px;
    border-top: 2px solid $lineColor;
    width: 300px;
    position: absolute;
    top: 5.5px;
  }
  .connect-left {
    right: 50%;
  }
  .connect-right {
    left: 50%;
  }
  span {
    z-index: 2;
    font-size: 12px;
  }
  .full {
    background-color: $blue;
    border-color: $blue;
  }
}
</style>
